module.exports = __webpack_public_path__ + "static/media/css-skinning-icon.b9a3a806.svg";